{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/TINETTI",
	"name": "TINETTI",
	"language": "fr-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "Échelle de TINETTI",
	"purpose": "Évaluation de l’équilibre et de la marche",
	"description": "Un score inférieur à 26 signifie généralement qu’il y a un problème ; plus le score est bas, plus le problème est important. Un score inférieur à 19 signifie que le risque de chute est multiplié par cinq.",
	"item": [
		{
			"linkId": "100100",
			"text": "ÉQUILIBRE",
			"type": "group",
			"item": [
				{
					"linkId": "100100_helpText",
					"text": "Assise sur une chaise dure, sans accoudoirs donc, la personne testée effectue les manœuvres suivantes.",
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				},
				{
					"linkId": "100200",
					"prefix": "1.",
					"text": "Équilibre en position assise",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "100201",
								"display": "Penche ou s’affale"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "100202",
								"display": "Position assise stable et sûre"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					]
				},
				{
					"linkId": "100300",
					"prefix": "2.",
					"text": "Se mettre debout",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "100301",
								"display": "Impossible sans aide"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "100302",
								"display": "Possible à l’aide d’un appui des bras"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "100303",
								"display": "Possible sans l’aide d’un appui des bras"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				},
				{
					"linkId": "100400",
					"prefix": "3.",
					"text": "Tentatives pour se mettre debout",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "100401",
								"display": "Impossible sans aide"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "100402",
								"display": "Possible avec plus d’une tentative"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "100403",
								"display": "Possible après une tentative"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				},
				{
					"linkId": "100500",
					"prefix": "4.",
					"text": "Équilibre debout (5 premières secondes)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "100501",
								"display": "Instable (vacille, bouge les pieds et le tronc)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "100502",
								"display": "Stable avec appui (déambulateur, canne ou autre)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "100503",
								"display": "Stable sans le moindre appui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				},
				{
					"linkId": "100600",
					"prefix": "5.",
					"text": "Équilibre debout",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "100601",
								"display": "Instable"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "100602",
								"display": "Stable, écart entre les pieds > 10 cm ou appui des bras"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "100603",
								"display": "Pieds joints, sans appui des bras"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				},
				{
					"linkId": "100700",
					"prefix": "6.",
					"text": "Poussée sur le sternum (3x) (pieds joints)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "100701",
								"display": "Commence à vaciller"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "100702",
								"display": "Vacille mais se redresse"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "100703",
								"display": "Stable"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				},
				{
					"linkId": "100800",
					"prefix": "7.",
					"text": "Yeux fermés (pieds joints)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "100801",
								"display": "Instable"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "100802",
								"display": "Stable"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					]
				},
				{
					"linkId": "100900",
					"prefix": "8.",
					"text": "Rotation de 360°",
					"type": "group",
					"item": [
						{
							"linkId": "101000",
							"text": "Petits pas",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"required": true,
							"answerOption": [
								{
									"valueCoding": {
										"code": "101001",
										"display": "Petits pas irréguliers"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 0
										}
									]
								},
								{
									"valueCoding": {
										"code": "101002",
										"display": "Petits pas réguliers"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 1
										}
									]
								}
							]
						},
						{
							"linkId": "101100",
							"text": "Stabilité",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"required": true,
							"answerOption": [
								{
									"valueCoding": {
										"code": "101101",
										"display": "Instable (vacille)"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 0
										}
									]
								},
								{
									"valueCoding": {
										"code": "101102",
										"display": "Stable"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 1
										}
									]
								}
							]
						}
					]
				},
				{
					"linkId": "101200",
					"prefix": "9.",
					"text": "S’asseoir",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "101201",
								"display": "Peu sûr (tombe, calcule mal la distance)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "101202",
								"display": "Utilise les bras"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "101203",
								"display": "Mouvements sûrs et aisés"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				}
			]
		},
		{
			"linkId": "101300",
			"text": "MARCHE",
			"type": "group",
			"item": [
				{
					"linkId": "101300_helpText",
					"text": "Debout avec l’examinateur dans un couloir ou une chambre, la personne marche d’abord à un rythme ordinaire, puis revient d’un pas plus rapide mais sûr (en utilisant ses propres aides : par ex. canne ou cadre de marche).",
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				},
				{
					"linkId": "101400",
					"prefix": "10.",
					"text": "Se mettre en marche au premier signal",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "101401",
								"display": "Hésitation ou diverses tentatives"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "101402",
								"display": "Sans hésitation"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					]
				},
				{
					"linkId": "101500",
					"prefix": "11.",
					"text": "Longueur et hauteur du pas",
					"type": "group",
					"item": [
						{
							"linkId": "101600",
							"text": "Pied D en mouvement longueur du pas",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"required": true,
							"answerOption": [
								{
									"valueCoding": {
										"code": "101601",
										"display": "Ne dépasse pas le pied G au repos"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 0
										}
									]
								},
								{
									"valueCoding": {
										"code": "101602",
										"display": "Dépasse le pied G au repos"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 1
										}
									]
								}
							]
						},
						{
							"linkId": "101700",
							"text": "Pied D en mouvement hauteur du pas",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"required": true,
							"answerOption": [
								{
									"valueCoding": {
										"code": "101701",
										"display": "Ne se détache pas du sol"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 0
										}
									]
								},
								{
									"valueCoding": {
										"code": "101702",
										"display": "Se détache du sol"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 1
										}
									]
								}
							]
						},
						{
							"linkId": "101800",
							"text": "Pied G en mouvement longueur du pas",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"required": true,
							"answerOption": [
								{
									"valueCoding": {
										"code": "101801",
										"display": "Ne dépasse pas le pied D au repos"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 0
										}
									]
								},
								{
									"valueCoding": {
										"code": "101802",
										"display": "Dépasse le pied D au repos"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 1
										}
									]
								}
							]
						},
						{
							"linkId": "101900",
							"text": "Pied G en mouvement hauteur du pas",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"required": true,
							"answerOption": [
								{
									"valueCoding": {
										"code": "101901",
										"display": "Ne se détache pas du sol"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 0
										}
									]
								},
								{
									"valueCoding": {
										"code": "101902",
										"display": "Se détache du sol"
									},
									"extension": [
										{
											"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
											"valueDecimal": 1
										}
									]
								}
							]
						}
					]
				},
				{
					"linkId": "102000",
					"prefix": "12.",
					"text": "Symétrie du pas",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "102001",
								"display": "Inégalité des pas G et D"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "102002",
								"display": "Égalité des pas G et D"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					]
				},
				{
					"linkId": "102100",
					"prefix": "13.",
					"text": "Continuité du pas",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "102101",
								"display": "Arrêts ou discontinuité des pas"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "102102",
								"display": "Les pas semblent continus"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					]
				},
				{
					"linkId": "102200",
					"prefix": "14.",
					"text": "Marche déviante",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "102201",
								"display": "Nette déviance"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "102202",
								"display": "Déviance moyenne ou utilisation d’une aide à la marche"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "102203",
								"display": "Marche droite sans aide"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				},
				{
					"linkId": "102300",
					"prefix": "15.",
					"text": "Tronc",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "102301",
								"display": "Mouvement prononcé du tronc ou utilisation d’une aide à la marche"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "102302",
								"display": "Pas de mouvement du tronc mais flexion des genoux, du dos ou écartement des bras"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "102303",
								"display": "Droit sans aide à la marche"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					]
				},
				{
					"linkId": "102400",
					"prefix": "16.",
					"text": "Écartement des pieds",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "102401",
								"display": "Talons séparés"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "102402",
								"display": "Talons se touchant presque lors de la marche"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					]
				}
			]
		}
	]
}
